export default {
  'nav.brandVision': 'Who We Are',
  'nav.strategicPositioning': 'Where We Are',
  'nav.coreBusiness': 'What We Do',
  'nav.competitiveAdvantage': 'Why Choose Us',
  'nav.developmentRoadmap': 'Our Roadmap',
  'nav.careers': 'Join Us',
  'nav.backToHome': 'Back to Home',
  'nav.brandStory': 'Brand Story',

  'footer.companyName': 'AX Axis International Holding Limited',
  'footer.companyNameEn': 'AX AXIS INTERNATIONAL HOLDING LIMITED',
  'footer.tagline': 'Data Returns to the Axis. From chip-level storage to top-tier architecture, building a full-chain private data ecosystem.',
  'footer.business': 'Business Segments',
  'footer.business.storageChips': 'Storage Chips',
  'footer.business.terminalDevices': 'Terminal Devices',
  'footer.business.privateCloudNAS': 'Private Cloud NAS',
  'footer.business.enterpriseNetwork': 'Enterprise Network',
  'footer.aboutUs': 'About Us',
  'footer.aboutUs.brandVision': 'Who We Are',
  'footer.aboutUs.strategicPositioning': 'Where We Are',
  'footer.aboutUs.developmentRoadmap': 'Our Roadmap',
  'footer.aboutUs.careers': 'Join Us',
  'footer.contact': 'Contact',
  'footer.addressLine1': 'Unit A, 19/F, Two Chinachem Central, 26 Des Voeux Road Central, Central, Hong Kong',
  'footer.phoneLabel': 'Tel: ',
  'footer.emailLabel': 'Email: ',
  'footer.copyright': '© {{year}} AX Axis International Holding Limited. All rights reserved.',

  'contact.infoTitle': 'Contact Information',
  'contact.addressTitle': 'Address',
  'contact.emailTitle': 'Email',
  'contact.reachUs': '',
  'contact.web3MissingKey': 'Web3Forms access key is not configured. Please contact the administrator.',

  'contact.label': '',
  'contact.title': 'Contact Us',
  'contact.description': 'Have questions or partnership inquiries, leave us a message and we will get back to you as soon as possible.',
  'contact.nameLabel': 'Name',
  'contact.namePlaceholder': 'Your name',
  'contact.emailLabel': 'Email',
  'contact.emailPlaceholder': 'your@email.com',
  'contact.phoneLabel': 'Phone',
  'contact.phonePlaceholder': 'Your phone number (optional)',
  'contact.messageLabel': 'Message',
  'contact.messagePlaceholder': 'Tell us about your inquiry...',
  'contact.submit': 'Send Message',
  'contact.submitting': 'Sending...',
  'contact.success': 'Message sent successfully!',
  'contact.error': 'Please check your input and try again.',
};